const icnos = {
  location:
    "https://www.google.com/maps/place/Atto+Atelier/@12.9622412,77.6380127,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae141b15177bf9:0x3aed26cadd7d9232!8m2!3d12.962236!4d77.640593!16s%2Fg%2F1q6jdlc5x?entry=ttu&g_ep=EgoyMDI1MDUyOC4wIKXMDSoASAFQAw%3D%3D",
  linkDln: "https://in.linkedin.com/company/atto-atelier",
  facebook: "https://www.facebook.com/p/Atto-Atelier-100076582644683/",
  mail:"mailto:reachus@atto.co.in",
  instagram: "https://www.instagram.com/atto_atelier/",
  phone: "tel:+91 8040124858",
};

export default icnos;
